<template>
  <form @submit.prevent>
    <div
      class="form-group invite-form"
      v-for="(email, index) in emailsToInvite"
      :key="`invite-${index}`"
    >
      <input
        type="email"
        v-model="email.email"
        placeholder="Enter user email"
        :key="index"
      />
    </div>
    <div class="invite-button">
      <button @click="addEmail">
        + ADD USER
      </button>
    </div>

    <div class="text-center flex justify-center">
      <button
        id="invite-btn"
        class="button-gemnote button-gemnote--small"
        :class="{ 'button-gemnote--disabled': sendingInvitations }"
        :disabled="sendingInvitations"
        @click="sendInvites"
      >
        <span>
          {{
            emailsToInvite.length === 1 ? 'Send invitation' : 'Send invitations'
          }}
        </span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import Util from '@/mixins/Util'

export default {
  name: 'InviteForm',
  props: {
    isOnBoardFlow: {
      type: Boolean,
      default: false
    }
  },
  mixins: [Util],
  data: function() {
    return {
      emailsToInvite: [{ email: '', admin: true }]
    }
  },
  computed: mapState({
    sendingInvitations: state => state.team.sendingInvitations
  }),
  methods: {
    addEmail() {
      this.emailsToInvite.push({ email: '', admin: true })
    },
    changeRole(index, isAdmin) {
      this.emailsToInvite[index].admin = isAdmin
    },
    sendInvites() {
      this.$store.dispatch('team/createAndSendInvitation', this.emailsToInvite)
    }
  },
  watch: {
    sendingInvitations(oldState) {
      if (oldState === false) {
        this.emailsToInvite = [{ email: '', admin: true }]
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.button-gemnote {
  width: auto;
  font-size: 1rem;
  font-weight: bold;
  white-space: unset;
  padding: 0 1.5rem;
  background: $pebble;
  color: $linen;
  border: 1px solid $onyx;

  &:hover {
    background: $main-white;
    color: $onyx;
    opacity: 0.8;
  }
}

form {
  width: 80%;
  height: 100%;
  margin: 0 auto;

  .page-header {
    margin-bottom: 0;
  }

  .text {
    margin-top: 0px;
    text-align: left;
    font-weight: 500;
  }

  a:hover {
    color: $onyx;
  }
}

.active {
  border-bottom: 1px solid;
}

.invite-button {
  text-align: left;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  padding-top: 0.5rem;

  button {
    background: $linen;
    border: 1px solid #232220;
    border-radius: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.875rem;
    font-size: 0.75rem;
    padding: 0 0.875rem;
    color: #232220;
  }

  p {
    margin-left: 1rem;
    font-size: 1rem;
    color: $main-white;
    cursor: pointer;
  }
}

.invite-form__no-valid-email {
  padding: 1rem 0px;
  text-align: left;
  color: red;
}

@media (max-width: 1000px) {
  form {
    width: 100%;

    .page-header {
      font-size: 25px;
    }
  }
}
::placeholder {
  color: $pebble;
}
</style>
